const order = state => state.order
const filter = state => state.filter
const report = state => state.report
const source = state => state.source
const reports = state => state.reports

export default {
  order,
  filter,
  report,
  source,
  reports
}
